module.exports = __webpack_public_path__ + "img/logo_coach.fe35cb56.png";